// Displays a success message after the contact form is submitted
import React from 'react';
import { CheckCircle } from 'lucide-react';
import { EMAILJS_CONFIG } from '@/config/emailjs';
import { Button } from '@/components/ui/button';
import { useLanguage } from '@/contexts/language/LanguageContext';
import { contactFormCopy } from '@/contexts/language/translations/pages/contactForm';

// Props for the FormSuccessMessage component
interface FormSuccessMessageProps {
  service: string; // The service the user inquired about
  onReset?: () => void; // Optional callback to reset the form
}

const FormSuccessMessage: React.FC<FormSuccessMessageProps> = ({ service, onReset }) => {
  const { language } = useLanguage();
  const c = contactFormCopy[language];
  return (
    <div className="flex flex-col items-center justify-center text-center py-8">
      {/* Success icon */}
      <div className="w-16 h-16 rounded-full bg-primary/10 flex items-center justify-center mb-4">
        <CheckCircle className="w-8 h-8 text-primary" />
      </div>
      {/* Main success message */}
      <h4 className="text-xl font-medium mb-2">{c.successTitle}</h4>
      <p className="text-muted-foreground mb-6">
        {c.successText}
      </p>
      
      {/* Button to allow user to send another message */}
      {onReset && (
        <Button 
          variant="outline" 
          size="sm" 
          onClick={onReset}
        >
          {c.sendAnother}
        </Button>
      )}
    </div>
  );
};

export default FormSuccessMessage;
